import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import 'rxjs/add/operator/map'
import { User } from "../models/user";
import { serverPort, base_url } from "../../../server/src/config/config";

@Injectable()
export class UserService {
  constructor(private http: Http) {
  }

  // getAll() {
  //   return this.http.get('/v1/users', this.jwt()).map((response: Response) => response.json());
  // }

  // getById(id:number) {
  //   return this.http.get(`${base_url}/v1/users/` + id).map((response:Response) => response.json());
  // }

  create(user: User) {
    return this.http.post(`${base_url}/v1/users`, user).map((response: Response) => response.json());
  }


  // update(user: User) {
  //   return this.http.put('/v1/users/' + user.id, user, this.jwt()).map((response: Response) => response.json());
  // }

  // delete(id: number) {
  //   return this.http.delete('/v1/users/' + id, this.jwt()).map((response: Response) => response.json());
  // }

  // private helper methods

  // private jwt() {
  // // create authorization header with jwt token
  //  let currentUser = JSON.parse(localStorage.getItem('currentUser'));
  // if (currentUser) {
  //   let headers = new Headers({'Authorization': 'Bearer ' + currentUser.email});
  //   return new RequestOptions({headers: headers});
  // }
  // }
}



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/services/user.service.ts